module.exports = __webpack_public_path__ + "img/dove.5828fc47.jpg";